import './index.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { ThemeProvider } from '@/components/theme-provider'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element #root not found in index.html')
}

// Optional in-browser mock backend for dev + browser QA. When VITE_USE_MSW is
// "true" we start the MSW service worker (same seed-anchored handlers the tests
// use) BEFORE mounting, so every /api/admin/* screen renders with realistic
// multi-tenant data and no live ADMIN service. The import is dynamic so msw is
// never pulled into a production bundle.
async function enableMocking(): Promise<void> {
  if (import.meta.env.VITE_USE_MSW !== 'true') return
  const { startMockWorker } = await import('@/test/browser')
  await startMockWorker()
}

function mount() {
  createRoot(rootEl!).render(
    <StrictMode>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </StrictMode>,
  )
}

enableMocking().finally(mount)
